import { render, staticRenderFns } from "./CreateEditUnit.vue?vue&type=template&id=f4381fd8"
import script from "./CreateEditUnit.vue?vue&type=script&lang=js"
export * from "./CreateEditUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports